import React from "react";
import { useDowntime } from "../../store/downtime/hooks";

import { ServiceStatus } from "../../store/downtime/types";

import { AlertWithMargin, DowntimeAlertWrapper } from "./styled";

export const DowntimeAlert = () => {
  const { current: downtime } = useDowntime();

  if (!downtime || downtime.services.length === 0) {
    return null;
  }

  return (
    <>
      <DowntimeAlertWrapper>
        {downtime.services.map((downtimeStatus: ServiceStatus) => (
          <div key={`${downtimeStatus.name}-downtime-container`}>
            {downtimeStatus.isDown && (
              <AlertWithMargin
                key={`${downtimeStatus.name}-down-error`}
                title={downtimeStatus.isDownTitle}
                description={downtimeStatus.isDownMessage}
                variant="error"
              />
            )}
            {downtimeStatus.isUnstable && (
              <AlertWithMargin
                key={`${downtimeStatus.name}-unstable-warning`}
                title={downtimeStatus.isUnstableTitle}
                description={downtimeStatus.isUnstableMessage}
                variant="warning"
              />
            )}
          </div>
        ))}
      </DowntimeAlertWrapper>
    </>
  );
};
